import Invoices from './Invoices.vue'
import CreateInvoice from './CreateInvoice.vue'
import InvoicesList from './InvoicesList.vue'
import InvoiceDetails from './InvoiceDetails.vue'
export default {
    path: 'invoices', component: Invoices, children: [
        {
            path:'', component: InvoicesList
        },
        {
            path:'create', component: CreateInvoice,
        },
        {
            path:':id', component: InvoiceDetails
        }
    ]
}
